import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
import echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    timestampsLine: Array,
    dianliuLine: Array,
    dianliuLine1: Array,
    shengyurongliangLine: Array,
    yachaLine: Array,
    zongdianyaDataLine: Array,
    chongdianDataLine: Array,
    fangdianDataLine: Array,
    moswendu: Array,
    huanjingwendu: Array,
    NTC4: Array,
    NTC3: Array,
    NTC2: Array,
    NTC1: Array,
    NTC5: Array,
    NTC6: Array,
    NTC7: Array,
    NTC8: Array,
    NTC9: Array,
    NTC10: Array,
    chongdianmos: Number,
    fangdianmos: Number,
    alarm9_str: Array,
    alarm10_str: Array,
    alarm11_str: Array
  },
  data: function data() {
    return {
      dom: null,
      alarm9Data: []
    };
  },
  methods: {
    Alarms9Text: function Alarms9Text() {
      return ["低电量告警", "MOS高温告警", "环境低温告警", "环境高温告警", "放电低温告警", "充电低温告警", "放电高温告警", "充电高温告警", "预留", "电芯故障告警", "放电过流告警", "充电过流告警", "总压低压告警", "总压过压告警", "单体低压告警", "单体过压告警"];
    },
    Alarms10Text: function Alarms10Text() {
      return ["Fully（充满）", "环境低温保护", "环境高温保护", "MOS高温保护", "放电低温保护（电芯）", "充电低温保护（电芯）", "放电高温保护（电芯）", "充电高温保护（电芯）", "充电器高压", "短路", "放电过流保护", "充电过流保护", "总压过放保护", "总压过压保护", "单体过放保护", "单体过压保护"];
    },
    Alarms11Text: function Alarms11Text() {
      return ["", "", "", "", "", "", "", "", "加热膜故障", "限流故障", "放电过采样芯片故障流保护", "电芯故障", "", "温度传感器故障", "放电MOS故障", "充电MOS故障"];
    },
    resize: function resize() {
      this.dom.resize();
    },
    setChartOptions: function setChartOptions() {
      var _this = this,
          _ref,
          _ref2;

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false
          },
          formatter: function formatter(params) {
            var time = _this.timestampsLine[params[0].dataIndex];
            var tooltipContent = "".concat(time, "<br/>");
            console.log("paramsparams", params);
            params.forEach(function (param) {
              var seriesName = param.seriesName;
              var value = param.data;
              var color = param.color; // 添加颜色原点

              if (!isNaN(value) && !(seriesName === "NTC1(℃)" && value === 0) && !(seriesName === "NTC2(℃)" && value === 0) && !(seriesName === "NTC3(℃)" && value === 0) && !(seriesName === "NTC4(℃)" && value === 0) && !(seriesName === "NTC5(℃)" && value === 0) && !(seriesName === "NTC6(℃)" && value === 0) && !(seriesName === "NTC7(℃)" && value === 0) && !(seriesName === "NTC8(℃)" && value === 0) && !(seriesName === "NTC9(℃)" && value === 0) && !(seriesName === "NTC10(℃)" && value === 0)) {
                tooltipContent += "<span style=\"display:inline-block;width:10px;height:10px;background-color:".concat(color, ";margin-right:5px;border-radius: 5px;\"></span>");
                tooltipContent += "".concat(seriesName, ": ").concat(value, "<br/>");
              }
            }); // 处理告警信息

            var currentAlarms = _this.alarm9_str[params[0].dataIndex];

            var alarms = _this.Alarms9Text(); // 确保这个方法返回告警数组


            if (currentAlarms) {
              currentAlarms.split("").forEach(function (bit, index) {
                if (bit === "1" && alarms[index]) {
                  tooltipContent += "<span style=\"display:inline-block;width:10px;height:10px;background-color:#ECF004;margin-right:5px;border-radius: 5px;\"></span>";
                  tooltipContent += "".concat(alarms[index], "<br/>");
                }
              });
            } // 处理保护信息


            var currentBaohu = _this.alarm10_str[params[0].dataIndex];

            var baohu = _this.Alarms10Text(); // 确保这个方法返回保护数组


            if (currentBaohu) {
              currentBaohu.split("").forEach(function (bit, index) {
                if (bit === "1" && baohu[index]) {
                  tooltipContent += "<span style=\"display:inline-block;width:10px;height:10px;background-color:red;margin-right:5px;border-radius: 5px;\"></span>";
                  tooltipContent += "".concat(baohu[index], "<br/>");
                }
              });
            } // 处理故障信息 - 注意这里应该是 alarm11_str


            var currentGuzhang = _this.alarm11_str[params[0].dataIndex]; // 修正为 alarm11_str

            var guzhang = _this.Alarms11Text(); // 确保这个方法返回故障数组


            if (currentGuzhang) {
              currentGuzhang.split("").forEach(function (bit, index) {
                if (bit === "1" && guzhang[index]) {
                  tooltipContent += "<span style=\"display:inline-block;width:10px;height:10px;background-color:red;margin-right:5px;border-radius: 5px;\"></span>";
                  tooltipContent += "".concat(guzhang[index], "<br/>");
                }
              });
            }

            return tooltipContent;
          }
        },
        legend: {
          data: [this.$t("SOC") + "(%)", this.$t("电压") + "(V)", this.$t("充电电流"), this.$t("放电电流"), this.$t("压差") + "(mV)", this.$t("MOS温度") + "(℃)"].concat(_toConsumableArray(this.NTC1 && this.NTC1.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC1") + "(℃)"] : []), _toConsumableArray(this.NTC2 && this.NTC2.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC2") + "(℃)"] : []), _toConsumableArray(this.NTC3 && this.NTC3.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC3") + "(℃)"] : []), _toConsumableArray(this.NTC4 && this.NTC4.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC4") + "(℃)"] : []), _toConsumableArray(this.NTC5 && this.NTC5.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC5") + "(℃)"] : []), _toConsumableArray(this.NTC6 && this.NTC6.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC6") + "(℃)"] : []), _toConsumableArray(this.NTC7 && this.NTC7.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC7") + "(℃)"] : []), _toConsumableArray(this.NTC8 && this.NTC8.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC8") + "(℃)"] : []), _toConsumableArray(this.NTC9 && this.NTC9.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC9") + "(℃)"] : []), _toConsumableArray(this.NTC10 && this.NTC10.some(function (value) {
            return value > 0;
          }) ? [this.$t("NTC10") + "(℃)"] : []), [this.$t("告警"), this.$t("保护"), this.$t("故障")]),
          orient: "vertical",
          right: "00px",
          top: "50px",
          itemGap: 10
        },
        axisPointer: {
          link: [{
            xAxisIndex: "all"
          }]
        },
        dataZoom: [{
          type: "slider",
          show: false,
          xAxisIndex: [0, 1],
          start: 0,
          end: 100
        }, {
          type: "inside",
          xAxisIndex: [0, 1]
        }],
        grid: [{
          left: 60,
          right: 150,
          height: "35%"
        }, {
          left: 60,
          right: 150,
          top: "55%",
          height: "35%"
        }],
        xAxis: [(_ref = {
          type: "category",
          axisLine: {
            onZero: false
          },
          data: this.timestampsLine,
          offset: 20
        }, _defineProperty(_ref, "axisLine", {
          lineStyle: {
            color: "rgba(127, 132, 139, 1)"
          }
        }), _defineProperty(_ref, "axisLabel", {
          color: "rgba(127, 132, 139, 1)"
        }), _ref), (_ref2 = {
          gridIndex: 1,
          type: "category",
          axisLine: {
            onZero: true
          },
          data: this.timestampsLine,
          position: "top",
          show: false,
          offset: 22
        }, _defineProperty(_ref2, "axisLine", {
          lineStyle: {
            color: "rgba(127, 132, 139, 1)"
          }
        }), _defineProperty(_ref2, "axisLabel", {
          color: "rgba(127, 132, 139, 1)"
        }), _ref2)],
        yAxis: [{
          type: "value",
          axisLine: {
            lineStyle: {
              color: "rgba(127, 132, 139, 0)"
            }
          },
          axisLabel: {
            color: "rgba(127, 132, 139, 1)"
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ccc"
            }
          }
        }, {
          gridIndex: 1,
          type: "value",
          inverse: true,
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#ccc"
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(127, 132, 139, 0)"
            }
          },
          axisLabel: {
            color: "rgba(127, 132, 139, 1)"
          }
        }],
        series: [{
          name: this.$t("电压") + "(V)",
          type: "line",
          symbolSize: 8,
          data: this.zongdianyaDataLine,
          itemStyle: {
            color: "rgba(255, 154, 46, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("SOC") + "(%)",
          type: "line",
          symbolSize: 8,
          data: this.shengyurongliangLine,
          itemStyle: {
            color: "rgba(25, 190, 107, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("充电电流"),
          type: "line",
          symbolSize: 8,
          data: this.dianliuLine,
          itemStyle: {
            color: "rgba(45, 140, 240, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("放电电流"),
          type: "line",
          symbolSize: 8,
          data: this.dianliuLine1,
          itemStyle: {
            color: "rgba(247, 114, 52, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("MOS温度") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.moswendu,
          itemStyle: {
            color: "#8D4EDA"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, // {
        //   name: this.$t("环境温度") + "(℃)",
        //   type: "line",
        //   symbolSize: 8,
        //   data: this.huanjingwendu,
        //   itemStyle: { color: "#9FBD1D" },
        //   markPoint: {
        //     data: [
        //       { type: "max", name: "Max" },
        //       { type: "min", name: "Min" },
        //     ],
        //   },
        // },
        {
          name: this.$t("NTC1") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC1,
          itemStyle: {
            color: "#E13EDB"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC2") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC2,
          itemStyle: {
            color: "rgba(240, 139, 180, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC3") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC3,
          itemStyle: {
            color: "rgba(150, 97, 188, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC4") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC4,
          itemStyle: {
            color: "rgba(101, 120, 155, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC5") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC5,
          itemStyle: {
            color: "rgba(0, 59, 122, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC6") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC6,
          itemStyle: {
            color: "rgba(141, 74, 187, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC7") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC7,
          itemStyle: {
            color: "rgba(49, 205, 158, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC8") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC8,
          itemStyle: {
            color: "rgba(23, 132, 169, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC9") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC9,
          itemStyle: {
            color: "rgba(59, 46, 125, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("NTC10") + "(℃)",
          type: "line",
          symbolSize: 8,
          data: this.NTC10,
          itemStyle: {
            color: "rgba(159, 217, 27, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }, {
          name: this.$t("告警"),
          type: "scatter",
          // 使用 scatter 类型
          symbolSize: 16,
          data: this.alarm9_str.map(function (str, index) {
            return str.includes("1") ? [index, 1] : null;
          }).filter(Boolean),
          itemStyle: {
            color: "#ECF004"
          }
        }, {
          name: this.$t("保护"),
          type: "scatter",
          symbolSize: 16,
          data: this.alarm10_str.map(function (str, index) {
            return str.includes("1") ? [index, 1] : null;
          }).filter(Boolean),
          itemStyle: {
            color: "red"
          } // tooltip: {
          //   show: true,
          //   formatter: (params) => {
          //     const time = this.timestampsLine[params[0].dataIndex];
          //     let tooltipContent = `${time}<br/>`;
          //     params.forEach((param) => {
          //       const seriesName = param.seriesName;
          //       const value = param.data;
          //       const color = param.color;
          //       if (!isNaN(value)) {
          //         tooltipContent += `<span style="display:inline-block;width:10px;height:10px;background-color:${color};margin-right:5px;border-radius: 5px;"></span>`;
          //         tooltipContent += `${seriesName}: ${value}<br/>`;
          //       }
          //     });
          //     return tooltipContent;
          //   },
          // },

        }, {
          name: this.$t("故障"),
          type: "scatter",
          symbolSize: 16,
          data: this.alarm11_str.map(function (str, index) {
            // 只检查后八位
            var lastEightBits = str.slice(-8);
            return lastEightBits.includes("1") ? [index, 1] : null;
          }).filter(Boolean),
          itemStyle: {
            color: "red"
          }
        }, {
          name: this.$t("压差") + "(mV)",
          type: "line",
          xAxisIndex: 1,
          yAxisIndex: 1,
          symbolSize: 8,
          data: this.yachaLine,
          itemStyle: {
            color: "rgba(14, 197, 192, 1)"
          },
          markPoint: {
            data: [{
              type: "max",
              name: "Max"
            }, {
              type: "min",
              name: "Min"
            }]
          }
        }]
      };
      this.dom.setOption(option);
      this.dom.on("click", this.handleChartClick);
    },
    handleChartClick: function handleChartClick(params) {
      console.log("paramsparams", params.name);
      var data = params.name;
      this.$emit("chartClick", {
        data: data
      });
    }
  },
  mounted: function mounted() {
    this.dom = echarts.init(this.$refs.dom);
    this.setChartOptions();
    on(window, "resize", this.resize);
  },
  watch: {
    timestampsLine: function timestampsLine(newValue) {
      this.setChartOptions();
    },
    dianliuLine: function dianliuLine() {
      this.setChartOptions();
    },
    shengyurongliangLine: function shengyurongliangLine() {
      this.setChartOptions();
    },
    yachaLine: function yachaLine() {
      this.setChartOptions();
    },
    zongdianyaDataLine: function zongdianyaDataLine() {
      this.setChartOptions();
    },
    chongdianDataLine: function chongdianDataLine() {
      this.setChartOptions(); // 监测充电数据变化
    },
    fangdianDataLine: function fangdianDataLine() {
      this.setChartOptions(); // 监测放电数据变化
    }
  },
  beforeDestroy: function beforeDestroy() {
    off(window, "resize", this.resize);
  }
};